<section class="landing-page container-fluid p-5">
  <div class="h-100 d-flex align-items-center flex-column">
    <div class="row">
      <div class="card" style="max-width: 60rem;">
        <img class="card-img-top p-5" src="/assets/sf-banner-generic.png" alt="spotfight-logo">
        <div class="card-body">
          <h2 class="card-title text-center mb-4">DAS SPOTFIGHT WRESTLING TIPPSPIEL</h2>
          <p class="card-text text-center">
            Als Patreon-Supporter oder YouTube-Kanalmitglied tippst du bei uns jede Saison alle Events von WWE, NXT und AEW. Hast du das Zeug, um dich gegen die große Community durchzusetzen? JETZT mitmachen, tolle Preise sichern und vor allem: Spaß haben!
          </p>
          <p class="card-text text-center">
            Alle Infos zu Teilnahmebedingungen, Regeln & mehr findest du <a [attr.href]=prices_url target="_blank">HIER</a></p>
          <div class="d-grid gap-2 px-5 mb-5">
            <a class="btn btn-danger" routerLink="login">Anmelden / Account erstellen</a>
          </div>
          <div class="d-flex justify-content-end">
            <a class="me-2" href="https://koelnsport-verlag.de/impressum/" target="_blank">Impressum</a>
            |
            <a class="ms-2" href="https://koelnsport-verlag.de/datenschutzerklaerung/" target="_blank">Datenschutz</a>
            |
            <a class="ms-2" href="data-privacy/google" target="_blank">Datenschutz - Google API</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
